import { api } from "@/lib/api";

export interface Branding {
  name: string;
  has_logo: boolean;
}

/** Public URL of the company logo image (served without auth for the login page). */
export const COMPANY_LOGO_URL = "/api/v1/public/branding/logo";

export function getBranding(): Promise<Branding> {
  return api.get<Branding>("/public/branding");
}
